import * as _ from 'lodash'
import {DimensionType} from "../PA.Core/PA.Core.IF.Hierarchy";
import {
    ICell,
    ICubePerspectiveOptions,
    ICubeSource,
    IDimensionCompositeKeys,
    IDimensionDistinctKeys
} from "./PA.HyperRectangle.IF";


export class CellUtils
{



    static getDistinctKeys(arrDimensionTypes: DimensionType[], arrCells: ICell[]): IDimensionDistinctKeys
    {
        const dctValues: {[dimTypeId: string]: {[key:string]: string}} = {}

        _.forEach(arrDimensionTypes, (aType) => {
            dctValues[aType] = {}
        })

        _.forEach(arrCells, (aCell: ICell) => {
            _.forEach(arrDimensionTypes, (aType) => {
                const keyValue = aCell.getKey(aType)
                if(_.isEmpty(keyValue))
                    return

                if(!(keyValue in dctValues[aType]))
                    dctValues[aType][keyValue] = keyValue
            })
        })


        const returnValue: IDimensionDistinctKeys = {}

        _.forEach(dctValues, (val, key) => {
            returnValue[key] = _.values(val)
        })

        return returnValue
    }

    static getCompositeKeys(arrDimensionTypes: DimensionType[], arrCells: ICell[],
                            bIncludeEmptyValue?: boolean, sEmptyValue?: string): IDimensionCompositeKeys
    {
        const returnValue: IDimensionCompositeKeys = {}
        _.forEach(arrCells, (aCell) => {

            let currentNode = returnValue
            for(const idx in arrDimensionTypes){
                const aDimType = arrDimensionTypes[idx]
                const idx_n = _.toNumber(idx)
                const bLast = (idx_n == (arrDimensionTypes.length - 1))

                let keyValue = aCell.getKey(aDimType)
                if(_.isEmpty(keyValue)){
                    if(bIncludeEmptyValue)
                        keyValue = sEmptyValue
                    else
                        break; // don't continue, go to next cell
                }

                if(keyValue in currentNode) {
                    // @ts-ignore
                    currentNode = currentNode[keyValue]
                    continue
                }

                if(bLast)
                    currentNode[keyValue] = keyValue
                else
                    currentNode[keyValue] = {}

                // @ts-ignore
                currentNode = currentNode[keyValue]

            }
            //--

        })

        return returnValue

    }

    static getFilterScope<CellType extends ICell>(cubeSource: ICubeSource,
                                                  perspectiveOptions: ICubePerspectiveOptions,
                                                  arrCells: CellType[],
                                                  dctCellLeafLevel: {[dimType:string]: string}): CellType[]
    {
        let bFilterAll = false
        const dctFilterKeys: {[dimType: string]: {[value: string | number]: string | number}} = {}

        //-- Create Filters
        _.forEach(perspectiveOptions.DimensionFilters || {}, (dimFilterProps, dimType) => {
            let leafLevel = dctCellLeafLevel?.[dimType] || ""
            if ('FilterByNodes' in dimFilterProps) {
                if(_.isEmpty(dimFilterProps.FilterByNodes)){
                    bFilterAll = true
                    return false
                }

                // Get Hierarchy
                const hier = cubeSource.getDimensionHierarchy(<DimensionType> dimType)
                if(_.isEmpty(hier)){
                    bFilterAll = true
                    return false
                }

                dctFilterKeys[dimType] = {}
                const dctKeys = dctFilterKeys[dimType]
                // Find All Leaf Nodes and add to Filters
                const leafNodes1 = _.filter(dimFilterProps.FilterByNodes, (a) => (a?.NodeLevel == leafLevel))
                const leafNodes2 = hier.getChildren(dimFilterProps.FilterByNodes, leafLevel)
                _.forEach([... leafNodes1, ... leafNodes2], (aLeaf) => {
                    dctKeys[aLeaf.NodeId] = aLeaf.NodeId
                })

            }
        })

        if(bFilterAll)
            return []

        // Run through filters
        let returnValue = arrCells
        _.forEach(dctFilterKeys, (dctKeys, dimType) => {
            returnValue = _.filter(returnValue, (aRow) => {
                return (aRow.getKey(dimType) in dctKeys)
            })
        })

        return returnValue

    }


}